/**
 * https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_throttle
 * @param func
 * @param duration
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const throttle = (func, duration) => {
    let lastTime = 0;
    return (...args) => {
        const now = Date.now();
        if (now - lastTime >= duration) {
            func(...args);
            lastTime = now;
        }
    };
};
/**
 * https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_debounce
 * @param func
 * @param wait
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = (func, wait, immediate = false) => {
    let timeout;
    const _func = (...args) => {
        clearTimeout(timeout);
        if (immediate && !timeout)
            func(...args);
        timeout = setTimeout(() => {
            timeout = undefined;
            if (!immediate)
                func(...args);
        }, wait);
    };
    _func.cancel = () => {
        clearTimeout(timeout);
        timeout = undefined;
    };
    return _func;
};
export const cloneDeep = (a) => {
    if (typeof a !== 'object' || a === null)
        return a;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (Array.isArray(a))
        return a.map(cloneDeep);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const res = {};
    for (const key in a) {
        res[key] = cloneDeep(a[key]);
    }
    return res;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const merge = (a, b) => {
    if (typeof b !== 'object' || b === null)
        return b;
    if (typeof a !== 'object' || a === null)
        return b;
    if (b instanceof Array) {
        if (!(a instanceof Array))
            return cloneDeep(b);
        if (b.length >= a.length)
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return b.map((target, i) => merge(a[i], target));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return a.map((origin, i) => i >= b.length ? cloneDeep(origin) : merge(origin, b[i]));
    }
    if (a instanceof Array)
        return cloneDeep(b);
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ans = {};
    for (const key of keysA) {
        if (keysB.includes(key)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions,@typescript-eslint/no-explicit-any
            ans[key] = merge(a[key], b[key]);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions,@typescript-eslint/no-explicit-any
            ans[key] = cloneDeep(a[key]);
        }
    }
    for (const key of keysB) {
        if (!keysA.includes(key)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions,@typescript-eslint/no-explicit-any
            ans[key] = cloneDeep(b[key]);
        }
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ans;
};
